import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Filter } from "lucide-react";
import {
  AdminAllOrdersFunc,
  GetOrderDeatils,
  UpateOrderStstus,
} from "../../redux/actions/Admin/AdminOrders";
import { Loading } from "notiflix";

const STATUS_OPTIONS = ["All", "Pending", "Refund", "Refund Reject", "Deliverd"];

function getStatusBadgeClass(status) {
  const s = (status || "").toLowerCase();
  if (s.includes("deliver") || s.includes("complete")) {
    return "bg-emerald-500/15 text-emerald-400";
  }
  if (s.includes("pending")) {
    return "bg-amber-500/15 text-amber-400";
  }
  if (s.includes("refund")) {
    return "bg-red-500/15 text-red-400";
  }
  return "bg-white/10 text-white/50";
}

function formatOrderId(id) {
  if (!id) return "—";
  const str = String(id);
  return `#${str.length > 8 ? str.slice(0, 8) : str}`;
}

function formatPayment(payments) {
  if (!payments) return "—";
  if (typeof payments === "string") return payments;
  if (typeof payments === "object") {
    return payments.method || payments.type || payments.cardBrand || JSON.stringify(payments);
  }
  return String(payments);
}

const Orders = ({ setActive }) => {
  const dispatch = useDispatch();
  const OrderData = useSelector((state) => state.AdminOrders.OrderData);
  const adminloading = useSelector((state) => state.user.adminloading);

  const [statusFilter, setStatusFilter] = useState("All");
  const [orderStatus, setOrderStatus] = useState("");
  const [orderId, setOrderId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(AdminAllOrdersFunc());
  }, [dispatch]);

  useEffect(() => {
    if (adminloading === true) {
      Loading.standard("Loading Please Wait", { svgColor: "#E52324" });
    } else {
      Loading.remove();
    }
  }, [adminloading]);

  const filteredOrders = useMemo(() => {
    const list = Array.isArray(OrderData) ? OrderData : [];
    if (statusFilter === "All") return list;
    return list.filter((item) => (item?.status || "").toLowerCase() === statusFilter.toLowerCase());
  }, [OrderData, statusFilter]);

  return (
    <>
      <div className="p-6 sm:p-8">
        <div className="mb-6">
          <h1 className="text-[22px] text-white" style={{ fontWeight: 800 }}>
            Orders
          </h1>
          <p className="text-white/30 text-[13px] mt-0.5">
            Total orders ({OrderData?.length ?? 0})
          </p>
        </div>

        {/* Status filters — new-ui style */}
        <div className="flex flex-wrap items-center gap-2 mb-6">
          <Filter className="w-4 h-4 text-white/20 shrink-0" strokeWidth={1.8} />
          {STATUS_OPTIONS.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => setStatusFilter(s)}
              className={`px-3 py-1.5 rounded-lg text-[11px] transition-all ${
                statusFilter === s
                  ? "bg-[#E52324]/15 text-[#E52324] border border-[#E52324]/20"
                  : "text-white/30 hover:text-white/50 border border-transparent hover:bg-white/[0.03]"
              }`}
              style={{ fontWeight: 600 }}
            >
              {s}
            </button>
          ))}
        </div>

        <div className="bg-[#0B1120] border border-[#1a1f30] rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-[#1a1f30]">
                  {[
                    "Order ID",
                    "Ticket Type",
                    "Status",
                    "Total Tickets",
                    "Total Amount",
                    "Payment Method",
                    "Action",
                  ].map((h) => (
                    <th
                      key={h}
                      className="text-left px-5 py-3.5 text-[9px] text-white/20 uppercase tracking-[0.15em] whitespace-nowrap"
                      style={{ fontWeight: 700 }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredOrders.length > 0 ? (
                  filteredOrders.map((item, index) => (
                    <tr
                      key={item?._id || index}
                      className="border-b border-[#1a1f30]/30 last:border-b-0 hover:bg-white/[0.015] transition-colors"
                    >
                      <td
                        className="px-5 py-3.5 text-[12px] text-blue-400 whitespace-nowrap"
                        style={{ fontWeight: 600 }}
                      >
                        {formatOrderId(item?._id)}
                      </td>
                      <td className="px-5 py-3.5 text-[12px] text-white/60 max-w-[180px] truncate">
                        {item?.type || "—"}
                      </td>
                      <td className="px-5 py-3.5">
                        <span
                          className={`inline-flex px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wider ${getStatusBadgeClass(item?.status)}`}
                          style={{ fontWeight: 600 }}
                        >
                          {item?.status || "—"}
                        </span>
                      </td>
                      <td className="px-5 py-3.5 text-[12px] text-white/40 text-center">
                        {item?.items?.length ?? 0}
                      </td>
                      <td className="px-5 py-3.5 text-[12px] text-white/80 whitespace-nowrap" style={{ fontWeight: 600 }}>
                        ${Number(item?.totalAmount || 0).toFixed(2)}
                      </td>
                      <td className="px-5 py-3.5 text-[10px] text-white/30 max-w-[140px] truncate">
                        {formatPayment(item?.payments)}
                      </td>
                      <td className="px-5 py-3.5">
                        <div className="flex items-center gap-2 flex-wrap">
                          <button
                            type="button"
                            className="text-[10px] text-white/30 hover:text-white px-2.5 py-1.5 rounded-lg border border-white/[0.06] hover:bg-white/[0.04] transition-all whitespace-nowrap"
                            style={{ fontWeight: 500 }}
                            onClick={() => {
                              setActive(10);
                              dispatch(GetOrderDeatils(item?._id));
                            }}
                          >
                            Details
                          </button>
                          <button
                            type="button"
                            className="text-[10px] text-[#E52324]/80 hover:text-[#E52324] px-2.5 py-1.5 rounded-lg border border-[#E52324]/20 hover:bg-[#E52324]/10 transition-all whitespace-nowrap"
                            style={{ fontWeight: 500 }}
                            onClick={() => {
                              setShowModal(true);
                              setOrderId(item?._id);
                              setOrderStatus(item?.status || "");
                            }}
                          >
                            Update Status
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="px-5 py-16 text-center text-white/30 text-[13px]">
                      {statusFilter === "All"
                        ? "No orders found."
                        : `No orders with status "${statusFilter}".`}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="fixed z-50 inset-0 flex items-center justify-center p-4 bg-black/60">
          <div
            className="w-full max-w-md rounded-2xl bg-[#0B1120] border border-[#1a2744] shadow-xl overflow-hidden"
            style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
          >
            <div className="px-5 py-4 border-b border-[#1a2744] flex items-center justify-between">
              <h3 className="text-[16px] text-white" style={{ fontWeight: 700 }}>
                Update Order Status
              </h3>
              <button
                type="button"
                onClick={() => {
                  setShowModal(false);
                  setOrderId(null);
                  setOrderStatus("");
                }}
                className="text-white/40 hover:text-white text-xl leading-none px-1"
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className="px-5 py-4">
              <label className="block text-[11px] text-white/40 uppercase tracking-wider mb-2" style={{ fontWeight: 600 }}>
                Status
              </label>
              <select
                className="w-full px-4 py-3 rounded-xl bg-white/[0.04] border border-white/[0.08] text-white text-[14px] focus:outline-none focus:ring-2 focus:ring-[#E52324]/30 cursor-pointer"
                onChange={(e) => setOrderStatus(e.target.value)}
                value={orderStatus}
              >
                <option value="" className="bg-[#0B1120]">
                  Select order status
                </option>
                <option value="Pending" className="bg-[#0B1120]">
                  Pending
                </option>
                <option value="Refund" className="bg-[#0B1120]">
                  Refund
                </option>
                <option value="Refund Reject" className="bg-[#0B1120]">
                  Refund Reject
                </option>
                <option value="Deliverd" className="bg-[#0B1120]">
                  Deliverd
                </option>
              </select>
            </div>
            <div className="px-5 py-4 border-t border-[#1a2744] flex justify-end gap-2">
              <button
                type="button"
                onClick={() => {
                  setShowModal(false);
                  setOrderId(null);
                  setOrderStatus("");
                }}
                className="px-4 py-2 rounded-xl text-[13px] text-white/50 hover:text-white hover:bg-white/[0.04] transition-all"
                style={{ fontWeight: 600 }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-xl bg-[#E52324] hover:bg-[#c41e1f] text-white text-[13px] transition-colors"
                style={{ fontWeight: 600 }}
                onClick={async () => {
                  if (!orderStatus) return;
                  await dispatch(UpateOrderStstus(orderId, orderStatus));
                  setShowModal(false);
                  setOrderId(null);
                  setOrderStatus("");
                  dispatch(AdminAllOrdersFunc());
                }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Orders;
